import React from 'react'

import PvBannerPNG from './images/pv-banner.png'
import { BANNER_WIDTH } from '@aytm/app/swidget/base/modules/viewport/types'
import style from './style.module.scss'

export interface IBannerProps {
  url?: string
  type: string
}

const Banner = React.memo<IBannerProps>(
  ({ url, type }) => {
    const bannerImage = 'pv' == type ? <img src={PvBannerPNG} width={BANNER_WIDTH} alt="PaidViewpoint" /> : null

    return (
      <div className={style.banner}>
        {url ? (
          <a href={url} target="_blank" rel="noreferrer">
            {bannerImage}
          </a>
        ) : (
          bannerImage
        )}
      </div>
    )
  },
  (prevProps, nextProps) => prevProps.url === nextProps.url && prevProps.type === nextProps.type
)

Banner.displayName = 'Banner'

export default Banner
